import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferOptionsView from 'buffers/BufferOptionsView';
import BufferTabView from 'buffers/BufferTabView';
import {performSignedFileQuery} from 'external-files/ExternalFileUtils';
import {ExternalEntryProtocolTabState} from 'notebook/entries/backbone/tabs/ExternalEntryProtocol';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import ExternalFileOptions from './ExternalFileOptions';
import ExternalFilePreview from './ExternalFilePreview';

export class ExternalEntryProtocolOptionsView extends BufferOptionsView<ExternalEntryProtocolTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override initialize(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.externalFile(), 'change:previewType change:url', this.render);
  }

  override render(): this {
    this.reactRoot = renderToDOM(
      <ExternalFileOptions
        availablePreviewTypes={this.model.externalFile().availablePreviewTypes()}
        name={this.model.get('title')}
        previewType={this.model.externalFile().previewType()}
        updateName={(name: string): void => {
          this.model.set({title: name});
          this.model.updateName(name);
        }}
        updatePreviewType={(previewType) => {
          this.model.updatePreviewType(previewType);
        }}
        generateDownloadUrl={async (isPreview) =>
          await performSignedFileQuery(
            this.model.externalFile().externalFileId(),
            this.model.externalFile().externalFileURL(),
            this.model.owningEntityApiId()
          )
        }
        printHandler={this.model.printHandler.bind(this.model)}
        printOptions={this.model.printOptions()}
        closeTab={() => {
          this.model.close();
        }}
      />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}

export class ExternalEntryProtocolTabView extends BufferTabView<ExternalEntryProtocolTabState> {
  reactRoot: ReactDOM.Root | null = null;

  static override initClass(): void {
    this.prototype.className = 'external-file-wrapper buffer-tab buffer-tab--no-padding';
  }

  override initialize(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(this.model.externalFile(), 'change:previewType change:url', this.render);
  }

  override render(): this {
    this.reactRoot = renderToDOM(
      <ExternalFilePreview
        url={this.model.externalFile().externalFileURL()}
        externalFileId={this.model.externalFile().externalFileId()}
        previewType={this.model.externalFile().previewType()}
        owningEntityApiId={this.model.owningEntityApiId()}
      />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}
ExternalEntryProtocolTabView.initClass();
